function steamAnim() {
    if (document.getElementById('cookieSteam')) {
        if (window.innerWidth >= 1200) {
            gsap.set('.gsw-cookie--steam', { opacity: 0 });

            gsap.to('.gsw-cookie--steam', { 
                opacity: .5, 
                duration: 8, 
                delay: 1.5,
                ease: "power2.out" 
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', steamAnim);

